import { DLMApplication, DLMSiteApplication, submitDLMPhase_3_2, submitDLMPhase_4_2, submitDLMPhase_5_1 } from '../../../../core/doclabel';

import {
    initDLMPhasA_4_1Values, DLMPhasA_4_1Schema,
    initDLMPhasANoteValues, DLMPhasANoteSchema,
    initDLMSubmitSignedDOCValues, DLMSubmitSignedDOCSchema,
    initDLMSubmitSignedROIValues, DLMSubmitSignedROISchema,
    initDLMConfirmationValues,
    DLMConfirmationSchema,
    DLMQuotationApproveSchema,
    initDLMQuotationApproveValues
} from '../forms';

import { 
    submitDLMPhase_2_2,
    submitDLMPhase_2_3,
    submitDLMPhase_3_3,
    submitDLMPhase_3_4,
    submitDLMPhase_4_1,
    submitDLMPhase_4_3,
    submitDLMPhase_4_4,
    submitDLMPhase_5_3,
    submitDLMPhase_6_1,
    submitDLMPhase_6_3,
    submitDLMPhase_7_1,
} from '../../../../core/doclabel';

import { cloneDeep, filter } from 'lodash';
import { ApplicationQuotation } from '../../../../core/applications';

const getApplicantResponseVars = (appState: string, workflow: string, siteDetails?: any, docModels?: any, siteROIModels?: any, quotations?: Array<ApplicationQuotation>) => {

  let initValues = null;
  let schema = {};
  let submitFunc = undefined;

  switch(appState) {        
    case 'Site Inspection - Issue': 
      initValues = cloneDeep(initDLMPhasANoteValues);
      schema = DLMPhasANoteSchema;              
      if (workflow === 'SiteInspect' || workflow === 'LabelInspect' || workflow === 'MandatoryDOC' ||  workflow === 'Label1b1' || workflow === 'LabelReplacement') {            
        submitFunc = submitDLMPhase_2_2;
      } else if (workflow === 'Label5' || workflow === 'MandatoryDOC1B') {
        submitFunc = submitDLMPhase_5_3;
      }
      break;

    case 'Program Manager Approval - Issue': 
      initValues = cloneDeep(initDLMPhasANoteValues);
      schema = DLMPhasANoteSchema;    
      if (workflow === 'DOC' || workflow === 'MandatoryDOC') {            
        submitFunc = submitDLMPhase_4_4;
      } else if (workflow === 'Label5' || workflow === 'DOCEdit' || workflow === 'DOCSplit' || workflow === 'ROIEdit' || workflow === 'ROISplit') {
        submitFunc = submitDLMPhase_2_3;
      }            
      break;
      
    case 'Applicant Confirmation': 
      initValues = cloneDeep(initDLMConfirmationValues);
      schema = DLMConfirmationSchema;
    
      if (workflow === 'DOC' || workflow === 'MandatoryDOC') {            
        submitFunc = submitDLMPhase_6_1;
      } else if (workflow === 'Label5') {
        submitFunc = submitDLMPhase_3_3;
      } else if (workflow === 'Label1b1') {
        submitFunc = submitDLMPhase_4_3;
      } else if (workflow === 'DOCEdit' || workflow === 'DOCSplit' || workflow === 'ROIEdit' || workflow === 'ROISplit') {
        submitFunc = submitDLMPhase_4_1;
      } else if (workflow === 'LabelReplacement') {
        submitFunc = submitDLMPhase_5_1;
      } else if (workflow === 'MandatoryDOC1B') {
        submitFunc = submitDLMPhase_7_1;
      }
      break;
    
    case 'Pending Inspection': 
      if (workflow === 'Label5') {
        initValues = cloneDeep(initDLMPhasA_4_1Values);
        schema = DLMPhasA_4_1Schema;
        submitFunc = submitDLMPhase_4_1;
      }
      break;

    case 'Component Check Issue':
    case 'Component Check - Issue':
      initValues = cloneDeep(initDLMPhasANoteValues);
      schema = DLMPhasANoteSchema;
      if (workflow === 'Label1b2' || workflow === 'Label1b3') {
        submitFunc = submitDLMPhase_2_2;
      }
      break;

    case 'Pending Re-Component Check':
      initValues = cloneDeep(initDLMPhasANoteValues);
      schema = DLMPhasANoteSchema;
      if (workflow === 'Label1b2' || workflow === 'Label1b3') {
        submitFunc = submitDLMPhase_2_3;
      }
      break;

    case 'Applicant Sign': 
      switch(workflow) {
        case 'DOC':
        case 'MandatoryDOC':
          submitFunc = submitDLMPhase_5_3;
          initValues = cloneDeep(initDLMSubmitSignedDOCValues);
          schema = DLMSubmitSignedDOCSchema;
          break;
                
        case 'DOCEdit':
        case 'DOCSplit':         
          submitFunc = submitDLMPhase_3_3;
          initValues = cloneDeep(initDLMSubmitSignedDOCValues);
          schema = DLMSubmitSignedDOCSchema;
          break;
        
        case 'Label1b1':
          submitFunc = submitDLMPhase_4_4;
          initValues = cloneDeep(initDLMSubmitSignedROIValues);
          schema = DLMSubmitSignedROISchema;
          break;
        
        case 'Label5':
          submitFunc = submitDLMPhase_3_4;
          initValues = cloneDeep(initDLMSubmitSignedROIValues);
          schema = DLMSubmitSignedROISchema;
          break;

        case 'ROIEdit': 
        case 'ROISplit':
          submitFunc = submitDLMPhase_3_3;
          initValues = cloneDeep(initDLMSubmitSignedROIValues);
          schema = DLMSubmitSignedROISchema;
          break;
        
        case 'LabelReplacement':
          submitFunc = submitDLMPhase_4_3;
          initValues = cloneDeep(initDLMSubmitSignedROIValues);
          schema = DLMSubmitSignedROISchema;
          break;

        case 'MandatoryDOC1B': 
          submitFunc = submitDLMPhase_6_3;
          initValues = cloneDeep(initDLMSubmitSignedDOCValues);
          schema = DLMSubmitSignedDOCSchema;
          break;

        default: 
          break;          
      }
      break;
    
    case 'Batch Testing - Issue': 
    case 'Sampling - Issue': 
    case 'Testing - Issue':                 
    case 'Pending Batch Testing':
    case 'Pending Sampling':
    case 'Pending Testing':    
      if (workflow === 'MandatoryDOC1B') {
        initValues = cloneDeep(initDLMPhasANoteValues);
        schema = DLMPhasANoteSchema;
        switch(appState) {
          case 'Batch Testing - Issue': 
            submitFunc = submitDLMPhase_2_2;
            break;
          case 'Sampling - Issue': 
          submitFunc = submitDLMPhase_3_2;
            break;
          case 'Testing - Issue':      
            submitFunc = submitDLMPhase_4_2;           
            break;                
          case 'Pending Batch Testing':
            submitFunc = submitDLMPhase_2_3;
            break;
          case 'Pending Sampling':
            submitFunc = submitDLMPhase_3_3;
            break;
          case 'Pending Testing':
            submitFunc = submitDLMPhase_4_3;
            break;
          default: 
            break;
        }
        
      }
      break;

    case 'Quotation Pending Approval': 
      if (workflow === 'TriggerTest') {
        initValues = cloneDeep(initDLMQuotationApproveValues);
        if (quotations && quotations.length > 0) {
          Object.assign(initValues, { 
            quotations: quotations.map(
              (o : ApplicationQuotation) => ({
                // extracted values
                id: o.id,
                quotationAttachment: o.quotationAttachment,
                quotationAttachmentId: o.quotationAttachment.id,
                quotationNumber: o.quotationNumber,
                // blank values
                endorsedQuotationAttachmentId: 0,
                endorsedQuotationAttachmentName: '',
                poAttachmentId: 0,
                poAttachmentName: '',
                poNumber: '',
              })
            ),
          });
        }          
        schema = DLMQuotationApproveSchema;                
        submitFunc = submitDLMPhase_2_2; 
      }
      break;    

            
    default:
        break;
  }

  if (initValues && workflow) {
    Object.assign(initValues, {workflow, appState});
    if (siteDetails) {
      Object.assign(initValues, {siteDetails});
    }
    if (docModels) {
      Object.assign(initValues, {docModels});
    }
    if (siteROIModels) {
      Object.assign(initValues, {siteROIModels});
    }
  }

  return { initValues, schema, submitFunc};
}

const extractSiteDetailModels = (dat: DLMApplication) => {

  if (! (dat && dat.siteApplications && dat.siteApplications.length > 0)) return [];

  const _sites = filter(dat.siteApplications, (o: DLMSiteApplication) => { return (! o.deleted); });
  
  return _sites.map((_site: DLMSiteApplication) => ({
    siteId: _site.id,
    projectName: _site.projectName,
    clientRefNo: _site.clientRefNo,
    prototypeTestReport: 0,
    trainingRecord: 0,
    methodOfStatement: 0,            
    productConstructionDrawing: 0,            
    sitePlanDrawing: 0,            
    siteChecklist: 0,            
    setscoROI: 0,            
    prototypeTestReportAttachmentName: 0,
    trainingRecordAttachmentName: 0,
    methodOfStatementAttachmentName: 0,
    productConstructionDrawingAttachmentName: 0,
    sitePlanDrawingAttachmentName: 0,
    siteChecklistAttachmentName: 0,
    setscoROIAttachmentName: 0,       
  }));
}



export {getApplicantResponseVars, extractSiteDetailModels};
